import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { PostulacionesService } from '../../services/postulaciones/postulaciones.service';
import { NgForm } from '@angular/forms';
import { MatrimonioService } from 'src/app/services/matrimonio/matrimonio.service';
import Swal from 'sweetalert2';
import { Hijo } from '../../models/hijo/hijo.model';
//import { TiposService } from '../../services/tipos/tipos.service';
import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { DialogTipoRechazo } from '../common/postulacion-rechazar.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { environment } from '../../../environments/environment';
import { isNullOrUndefined } from 'util';
import { isNull } from 'util';
declare const Rut: any;
export interface DialogData {
    archivo: any;
    idPostulacion: any;
    beneficiario: string;
    postulantes: any;
    tipoUnion: any;
    carga: any;    
    deshabilitado: boolean;
    presionaEditar: boolean;
    recarga: boolean;
    email: string;
    rutConyuge: string;
    tipoMatrimonios: any;
    tipo: any;
    fechaUnion: any;
    idUsuario: any;
    nombres: string;
    nombreCompleto: string;
    nombreCompletoConyuge: string;    
    mostrarEditar: string;
    rol: string;
    disponiblePago: any;
    mostrarAprobarButton: any;
    diasDiferencia: any;
}


@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/postulaciones/postulacion-matrimonio-validar.html',
    styleUrls: ['../../pages/postulaciones/postulaciones.component.css'],
})
export class DialogEditPostulacionMatrimonio {
    constructor(public dialogRef: MatDialogRef<DialogEditPostulacionMatrimonio>,
        public matrimonioService: MatrimonioService,
        private postulacionesService: PostulacionesService,
        @Inject(MAT_DIALOG_DATA) public data: DialogData, private dialog: MatDialog,) {
        let vm = this
        this.data.recarga = false
        this.data.rol = localStorage.getItem('rol')
        this.data.carga=''
        this.matrimonioService.traeTipoMatrimonio().then(
            tipo => this.data.tipoMatrimonios = tipo
        ).catch(error => console.log(error))
        
    }

    onRechazarClick(): void {
        let vm = this

        let dataRechazo: any =
        {
            idPostulacion: this.data.idPostulacion, tiposRechazo: [], tipoRechazo: '', email: this.data.email,
            nombres: this.data.nombres, nombreProducto: 'MATRIMONIO'
        }

        this.postulacionesService.motivoRechazo(2).then(rechazos => {
            dataRechazo.tiposRechazo = rechazos
        })
            .catch(error => {

                console.log(error)
            });

        const dialogRechazo = this.dialog.open(DialogTipoRechazo, { width: '50%', data: dataRechazo })

        dialogRechazo.afterClosed().subscribe(() => {

            vm.data.recarga = true
            vm.dialogRef.close()
        })
    }

    onAprobarClick(): void {


        let titular = true
        let rut = ''
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        if (!isNullOrUndefined(this.data.postulantes) && !isNullOrUndefined(this.data.postulantes[0].tipoCarga)) {

            rut = this.data.postulantes[0].rut
            titular = false
        } else {
            let limpiarRut = this.data.beneficiario.split("(");
            let obtenerRut = limpiarRut[1].split("-");
            rut = obtenerRut[0]
        }

        let vm = this
        let fechaIngresada = new Date(this.data.fechaUnion + 'T00:00')

        let fechaMinima = new Date()
        fechaMinima.setDate(fechaMinima.getDate() - this.data.diasDiferencia)


        this.postulacionesService.sinPostulacionesVigentes(2, rut, titular).then
            (
                response => {
                    /*
                    if(Object.values(response).length >1){            
                         vm.openAlertDialog('El rut ya tiene una solicitud de matrimonio ingresada, favor revisar.', 'btn-danger')
                         Swal.close();
                         return
                    }    
                    */
                    if (fechaIngresada < fechaMinima || fechaIngresada > new Date()) {
                        Swal.close();
                        this.openAlertDialog('La fecha de certificado ingresada no cumple con los estándares establecidos1. Favor revisar.', 'btn-dark')

                    } else {
                        const dialogRef = this.dialog.open(ConfirmationDialog, {
                            data: { message: '¿Esta seguro de aprobar la postulación?', buttonText: { ok: 'Si', cancel: 'No' } }
                        })

                        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                            if (confirmed) {
                                Swal.fire({
                                    allowOutsideClick: false,
                                    icon: 'info',
                                    text: 'Cargando...'
                                });
                                Swal.showLoading();
                                vm.postulacionesService.cambiarEstadoPostulacion(vm.data.idPostulacion, "DISPONIBLE PARA PAGO", idUsuarioSesion).then
                                    (
                                        () => {
                                            vm.data.recarga = true
                                            vm.dialogRef.close()
                                            Swal.close();
                                            vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                                        }
                                    )
                                    .catch
                                    (
                                        error => {
                                            Swal.close();
                                            console.log(error)
                                            vm.dialogRef.close()
                                            vm.openAlertDialog('La postulación no se ha podido aprobar.', 'btn-danger')
                                        }
                                    )
                            }
                        })
                    }

                }
            )
            .catch
            (
                () => {
                    /*if(fechaIngresada < fechaMinima || fechaIngresada > new Date())
                    {
                        Swal.close();
                        this.openAlertDialog('La fecha de certificado ingresada no cumple con los estándares establecidos2. Favor revisar.', 'btn-dark')
                        
                    }else{ */
                    const dialogRef = this.dialog.open(ConfirmationDialog, {
                        data: { message: '¿Esta seguro de aprobar la postulación?', buttonText: { ok: 'Si', cancel: 'No' } }
                    })

                    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
                        if (confirmed) {
                            Swal.fire({
                                allowOutsideClick: false,
                                icon: 'info',
                                text: 'Cargando...'
                            });
                            Swal.showLoading();
                            vm.postulacionesService.cambiarEstadoPostulacion(vm.data.idPostulacion, "DISPONIBLE PARA PAGO", idUsuarioSesion).then
                                (
                                    () => {
                                        vm.data.recarga = true
                                        vm.dialogRef.close()
                                        Swal.close();
                                        vm.openAlertDialog('La postulación se ha aprobado exitosamente.', 'btn-success')
                                    }
                                )
                                .catch
                                (
                                    error => {
                                        Swal.close();
                                        console.log(error)
                                        vm.dialogRef.close()
                                        vm.openAlertDialog('La postulación no se ha podido aprobar.', 'btn-danger')
                                    }
                                )
                        }
                    })
                    // }     

                }
            )

    }

    onEditarClick(): void {
        this.data.deshabilitado = false
        this.data.presionaEditar = true
    }

    onCancelarClick(): void { this.dialogRef.close() }

    onDescargarArchivosClick(postulacionId: any) {
        let vm = this

        vm.postulacionesService.traeArchivos(postulacionId).then
            (
                (archivos: any) => {
                    archivos.forEach(archivo => {
                        var fileURL = `${environment.urlBlob}/${archivo.url}`
                        window.open(fileURL, '_blank')
                    })

                }
            )
            .catch
            (
                error => {
                    console.log(error)
                    vm.openAlertDialog('Ha ocurrido un error para visualizar el archivo.', 'btn-danger')
                }
            )
    }

    onGuardarClick(form: NgForm) {

        let vm = this
        let idUsuarioSesion = localStorage.getItem("idUsuario")
        let idUsuario = this.data.idUsuario
        let fechaAdopcion = null;

        Swal.fire({
            allowOutsideClick: false,
            icon: 'info',
            text: 'Cargando...'
        });
        let tipoIngreso = 'MATRIMONIO'
        Swal.showLoading();
        let usuarioId: any
        let fechaIngresadaNac = new Date(this.data.fechaUnion + 'T00:00')
        let fechamaxima = new Date()

        for (let i = 0; i < this.data.tipoMatrimonios.length; i++) {
            if (this.data.fechaUnion == this.data.tipoMatrimonios[i].id)
                tipoIngreso = this.data.tipoMatrimonios[i].descripcion;
        }

        if (fechaIngresadaNac > fechamaxima && tipoIngreso == 'matrimonio') {
            Swal.close();
            this.openAlertDialog('La fecha de matrimonio no debe super la fecha actual. Favor revisar.', 'btn-dark')
            return false
        }

        let fechaNacIngresada = new Date(this.data.fechaUnion + 'T00:00')
        let fechaMinima = new Date()
        fechaMinima.setDate(fechaMinima.getDate() - this.data.diasDiferencia)

        if ((fechaNacIngresada < fechaMinima || fechaNacIngresada > new Date()) && tipoIngreso == 'matrimonio') {
            this.openAlertDialog('La Fecha de solicitud supera la vigencia de 180 dias o excede la fecha actual. Favor revisar.', 'btn-dark')
            Swal.close();
            return false
        }


        let fechaAdopIngresada = new Date(this.data.fechaUnion + 'T00:00')
    
        /*
        if (!this.data.archivo) {
          Swal.close();
          this.openAlertDialog('Debe cargar el certificado como archivo', 'btn-dark')
    
          return false
        }
        */
        if (!form.valid) {
            Swal.close();
            this.openAlertDialog('Debe ingresar todos los campos obligatorios', 'btn-dark')

            return false
        }

        /*
          if (this.data.archivo.tipo != "application/pdf" && this.data.archivo.tipo != "image/jpeg" &&
            this.data.archivo.tipo != "image/png" && this.data.archivo.tipo != "image/jpg") {
            Swal.close();
            this.openAlertDialog('Debe ingresar un archivo de tipo no modificable (PDF, PNG, JPEG, JPG)', 'btn-dark')
      
            return false
          }
          */

        let fechaUnion = this.data.fechaUnion.split('-')[2] + '-' +
            this.data.fechaUnion.split('-')[1] + '-' +
            this.data.fechaUnion.split('-')[0]



        this.matrimonioService.editarMatrimonio(this.data, fechaUnion, idUsuario, idUsuarioSesion).then
            (
                () => {
                    vm.data.recarga = true
                    vm.dialogRef.close()
                    Swal.close();
                    vm.openAlertDialog('La postulación se ha guardado exitosamente.', 'btn-success')
                }
            )
            .catch
            (
                (error: any) => {
                  
                   if (error.status == 402) {
                        vm.openAlertDialog('Documento emitido en periodo de carencia.', 'btn-danger')
                        Swal.close();
                    } else if(error.status == 412){
                        vm.openAlertDialog('Beneficio con fecha de evento anterior a la fecha de afiliación.', 'btn-danger')
                        Swal.close();    
                    } else{
                        vm.dialogRef.close()
                        Swal.close();
                        vm.openAlertDialog('La postulación no se ha logrado guardar.', 'btn-danger')
                   }
                    
                }
            )
        //}
    }


    openAlertDialog(mensaje: string, clase: string) {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }

    buscarHijo(rutABuscar) { 
        let rut = rutABuscar.split('-')[0] + rutABuscar.split('-')[1]   
        Swal.fire({
          allowOutsideClick: false,
          icon: 'info',
          text: 'Cargando...'
        });
        Swal.showLoading();
        let vm = this
        if (Rut(rutABuscar)) {       
          
            this.matrimonioService.buscarHijo(rut).then
              (
                (hijo: Hijo) => {
    
                  console.log(hijo)
                  vm.data.nombreCompletoConyuge = hijo.nombres
              
                  Swal.close();
                }
    
              ).catch(error => {
                console.log(error)
                Swal.close();
                vm.openAlertDialog('No se han encontrado usuarios con el RUT ingresado en el registro civil. Intente nuevamente.', 'btn-danger')
                vm.data.nombres = ''
                vm.data.nombreCompletoConyuge = ''
              
              })
        }else{
          Swal.close();
          this.openAlertDialog('El RUT es incorrecto. Favor Revisar', 'btn-danger')
          vm.data.nombreCompleto = ''
          vm.data.nombreCompletoConyuge = ''
        
        }
      }
}
